// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1BW5A","content":"LayoutSettings_content__2G3fZ"};